import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import server from '../../../api/server';
import Card from '../ui/Card';
import Button from '../ui/Button';
import DocumentsApplicant from './DocumentsApplicant';
import RequestDocCollectionCard from './RequestDocCollectionCard';
import EditDocCollectionModal from './EditDocCollectionModal';
import { DocumentIcon, DownloadIcon, PencilIcon } from '../ui/icons';

// Redesign of newadmin/DocumentCollection.js — same /docs/all blob download
// and Edit Document Collection flow.
const DocumentsSection = () => {
    const documents = useSelector((s) => s.admin.active_application.documents);
    const activeApplication = useSelector((s) => s.admin.active_application);
    const user = useSelector((s) => s.user);

    const [editOpen, setEditOpen] = useState(false);

    if (documents == null) {
        return <RequestDocCollectionCard />;
    }

    const downloadAll = async () => {
        const response = await server.post(
            '/docs/all',
            { file_upload_id: documents.id, id: user.token, path: documents.id },
            { responseType: 'blob' }
        );
        let blob = new Blob([response.data], { type: 'application/zip' });
        let objectUrl = URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = objectUrl;
        link.download = `${activeApplication.application.id}.zip`;
        link.click();
    };

    return (
        <>
            <EditDocCollectionModal open={editOpen} onClose={() => setEditOpen(false)} />
            <Card
                title="Document Collection"
                icon={<DocumentIcon className="h-5 w-5" />}
                actions={
                    <>
                        <Button variant="secondary" onClick={() => setEditOpen(true)}>
                            <PencilIcon className="h-4 w-4" />
                            Edit Document Collection
                        </Button>
                        <Button variant="secondary" onClick={downloadAll}>
                            <DownloadIcon className="h-4 w-4" />
                            Download All
                        </Button>
                    </>
                }
            >
                {Object.keys(documents.applicants).map((key) => (
                    <DocumentsApplicant key={key} applicantId={key} />
                ))}
            </Card>
        </>
    );
};

export default DocumentsSection;
